import React, { useRef, useState } from "react";
import ContactForm from "./ContactForm";

// Import Swiper React components
function Contactus() {
  
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: '',
        error: '',
        isSubmitting: false,
        isSuccess: false,
        successMessage: '',
      });

      const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleSubmit = async(e) => {
        e.preventDefault();
        if(formData.name.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Name is required',
            isSubmitting: false,
          }));
        }
        else if(formData.email.trim() !== '' && !formData.email.includes('@')){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Invalid email',
            isSubmitting: false,
          }));
        }
        else if(formData.phone.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Phone is required',
            isSubmitting: false,
          }));
        }
        else if(formData.message.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Message is required',
            isSubmitting: false,
          }));
        }
        else{
          setFormData((prevData) => ({
            ...prevData,
            error: '',
            isSubmitting: true,
            // isSuccess: true,
            // successMessage: 'Thank you for contacting us. We will get back to you soon.',
          }));
          

          const API_URL = "http://89.116.121.184/api/";
          // const API_URL = "http://localhost:8000/";
          const API_ENDPOINT = "HealthfitMailer";
          
          const requestData = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            address: formData.address,
            message: formData.message,
          };

          const response = await fetch(`${API_URL}${API_ENDPOINT}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
          });

          if(response.ok){
            setFormData((prevData) => ({
              ...prevData,
              isSuccess: true,
              successMessage: 'Thank you for contacting us. We will get back to you soon.',
            }));

            setFormData((prevData) => ({
              ...prevData,
              name: '',
              email: '',
              phone: '',
              address: '',
              message: '',
              error: '',
              isSubmitting: false,
            }));
            // setTimeout(() => {
            //   setFormData((prevData) => ({
            //     ...prevData,
            //     name: '',
            //     email: '',
            //     phone: '',
            //     address: '',
            //     message: '',
            //     error: '',
            //     isSubmitting: false,
            //     isSuccess: false,
            //     successMessage: '',
            //   }));
            // }, 3000);
          }
          else{
            setFormData((prevData) => ({
              ...prevData,
              error: 'Something went wrong. Please try again later.',
              isSubmitting: false,
            }));
          }


        // console.log('Form Data Submitted:', formData);
        // alert(`Submitted Data:\n${JSON.stringify(formData, null, 2)}`);
      };
    }

      
  return (
    <div className="App">

{/* <!-- Page banner Section Start --> */}
        <div class="section page-banner-section contact-back-img" >
            <div class="container">

                {/* <!-- Page banner Section Start --> */}
                <div class="page-banner-content">
                    <h2 class="page-title">Contact Us</h2>

                    <ul class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active">Contact</li>
                    </ul>
                </div>
                {/* <!-- Page banner Section End --> */}

            </div>
        </div>
        {/* <!-- Page banner Section End --> */}

        {/* <!-- Contact Map Start --> */}
        <div class="section section-padding-02" >
            <div class="container">


                {/* <!-- Contact Map Wrapper Start --> */}
                <div class="contact-map-wrapper">
                    <iframe id="gmap_canvas" src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Dietitian Neha Yaduvanshi | Nutritionist | Weight loss center | diabetes nutritionist | Jaipur, A/256, kirni phatak Rd, near Patanjali Store, Tara Nagar-A, Tara Nagar, Jhotwara, Jaipur, Rajasthan 302012&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                </div>
                {/* <!-- Contact Map Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Contact Map End --> */}

        {/* <!-- Contact Section Start --> */}
        <div class="section section-padding" style={{paddingBottom : 100}}>
            <div class="container">

                {/* <!-- Contact Wrapper Start --> */}
                <div class="contact-wrapper">
                    <div class="row justify-content-center">
                        <div class="col-lg-6">
                            {/* <!-- Contact Content Start --> */}
                            <div class="contact-content">

                                {/* <!-- Contact Title Start --> */}
                                <div class="contact-title">
                                    <h4 class="sub-title">Don't worry!</h4>
                                    <h2 class="main-title">If you have any query? Contact with us.</h2>
                                </div>
                                {/* <!-- Contact Title End --> */}

                                {/* <!-- Contact Form Start --> */}
                               <ContactForm /> 
                                {/* <!-- Contact Form End --> */}

                            </div>
                            {/* <!-- Contact Content End --> */}
                        </div>
                        <div class="col-lg-6">
                            {/* <!-- Contact Information Start --> */}
                            <div class="contact-information">
                                <div class="information-wrapper">

                                    <img class="shape" src="/assets/images/shape/shape-11.png" alt="" />

                                    <div class="single-info">
                                        <h3 class="info-title">Phone:</h3>

                                        <p>(+91) 8447009334</p>
                                        {/* <p>(+91) 8949979942</p> */}

                                    </div>
                                    <div class="single-info">
                                        <h3 class="info-title">Email:</h3>

                                        <p>healthfitsquare@gmail.com</p>
                                        {/* <p>healthfitsquare@gmail.com</p> */}

                                    </div>

                                    <div class="single-info">
                                        <h3 class="info-title">Timings:</h3>

                                        <p>Weekdays : 10:00 AM - 7:00 PM</p>
                                        <p>Sunday : Closed</p>

                                    </div>

                                    {/* <div class="single-info">
                                        <h3 class="info-title">Address:</h3>

                                        <p>A/256, Khirni Phatak Road,<br/>
                                        Near Patanjali Store, Tara Nagar-A, <br/>
                                        Tara Nagar Jhotwara, <br/>
                                        Jaipur, Rajasthan 302012
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                            {/* <!-- Contact Information End --> */}
                        </div>

                           {/* <!-- Question & Answer End -->  */}
                           <div class="question-answer" style={{border : 0}}>

<div class="row">
    <div class="col-xl-4">
        {/* <!-- Answer User List Start --> */}
        <div class="answer-user-list">

            {/* <!-- Single User Start --> */}
            <div class="single-user active">
                
                <div class="user-content"  style={{maxWidth : '100%', paddingBottom : 0}}>
                    <h6 class="name">Jaipur Main Office</h6>
                    <p style={{marginTop : 10, marginBottom : 5}}>A/256, Khirni Phatak Road,<br/>
            Near Patanjali Store, Tara Nagar-A, <br/>
            Tara Nagar Jhotwara, <br/>
            Jaipur, Rajasthan 302012</p>
            <h7 class="name">Phone : </h7><span style={{fontSize : 12, color : '#fff'}}>(+91) 8447009334</span>
                </div>
            </div>
            {/* <!-- Single User End --> */}
            </div>
            </div>

            <div class="col-xl-4">
        {/* <!-- Answer User List Start --> */}
        <div class="answer-user-list">

            {/* <!-- Single User Start --> */}
            <div class="single-user active">
                
                <div class="user-content" style={{maxWidth : '100%', paddingBottom : 0}}>
                    <h6 class="name">Jaipur Branch Office</h6>
                    <p style={{marginTop : 10, marginBottom : 5}}>T9 Security Services Private Limited,<br/>
                    Office No.06 Pilot No 8, <br/>
                    Arjunpuri, Imli Phatak, <br/>
            Jaipur, Rajasthan 302015</p>
            <h7 class="name">Phone : </h7><span style={{fontSize : 12, color : '#fff'}}>(+91) 8949979942</span>

                </div>
            </div>
            {/* <!-- Single User End --> */}
            </div>
            </div>


            <div class="col-xl-4">
        {/* <!-- Answer User List Start --> */}
        <div class="answer-user-list">

            {/* <!-- Single User Start --> */}
            <div class="single-user active">
                
                <div class="user-content"  style={{maxWidth : '100%', paddingBottom : 0}}>
                    <h6 class="name">Gurgaon Office</h6>
                    <p style={{marginTop : 10, marginBottom : 5}}>Floor, V- 29/22, First,<br/>
                    near DLF Club, <br/>
            DLF Phase 3, Nathupur,  <br/>
            Gurugram, Haryana 122002</p>
            <h7 class="name">Phone : </h7><span style={{fontSize : 12, color : '#fff'}}>(+91) 8949979942</span>

                </div>
            </div>
            {/* <!-- Single User End --> */}
            </div>
            </div>
            </div>
            </div>

                    </div>
                </div>
                {/* <!-- Contact Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Contact Section End --> */}


    </div>
  )
}

export default Contactus
